import React from 'react';

const HomeBackground = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="274.5" height="601.51" viewBox="0 0 274.5 601.51">
                <g>
                    <path d="M137.84,601.51H0v-542L71.71,0l66.14,59.48Z" transform="translate(-0.01 0)" fill="#00aa96"/>
                    <rect x="59.46" y="133.79" width="26.43" height="84.24" fill="#1c2284"/>
                    <rect x="59.46" y="275.87" width="26.43" height="84.24" fill="#1c2284"/>
                    <rect x="59.46" y="417.96" width="26.43" height="84.24" fill="#1c2284"/>
                </g>
                <g>
                    <path d="M274.51,601.51H136.66V257.32l71.7-59.47,66.15,59.47Z" transform="translate(-0.01 0)"
                          fill="#0096d7"/>
                    <rect x="196.12" y="275.87" width="26.43" height="84.24" fill="#e62d82"/>
                    <rect x="196.12" y="417.96" width="26.43" height="84.24" fill="#e62d82"/>
                </g>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="337.85" height="476.89" viewBox="0 0 337.85 476.89">
                <g>
                    <rect x="113.85" y="61.89" width="224" height="414" fill="#00aa96"/>
                    <rect x="112.15" width="46.7" height="475.89" fill="#1c2284"/>
                    <rect x="201.15" width="46.7" height="475.89" fill="#1c2284"/>
                    <path d="M291.15,61.89h46.7v414h-46.7Z" fill="#e62d82"/>
                </g>
                <g>
                    <rect x="69.23" y="416.6" width="8.83" height="60.29" fill="#e9d2c0"/>
                    <path d="M147.29,360.81a73.65,73.65,0,1,1-73.65-73.65h0a73.65,73.65,0,0,1,73.65,73.65" fill="#00aa96"/>
                </g>
            </svg>


        </>
    );
}

export default HomeBackground;
